//START GENAI@CHATGPT4
import { error, invalidParam } from 'common/errors';
import { pushUctpCheckout } from 'common/gamp';
import { markEnd, markStart } from 'common/instrumentation';
import orchCheckout from 'orch-communicator/external/checkout';
import { CheckoutRequest } from 'types/vsb-sdk/checkout';
import pushEvents from 'vsb-sdk/api/push-events';
import { CheckoutInputDataModelSelectCard } from 'vsb-sdk/schemas/checkout';

function validateInput(rawInput: CheckoutRequest) {
  if (typeof rawInput !== 'object') {
    return {
      actionCode: 'ERROR',
      error: error(
        'CARD_MISSING',
        `The "srcDigitalCardId" or "encryptedCard" parameter is required but is missing.`
      ).error,
      bindingStatus: 'UNBIND'
    };
  }

  const result = CheckoutInputDataModelSelectCard.safeParse(rawInput);

  if (!result.success) {
    const { issues } = result.error;

    if (
      issues.some(
        issue => issue.path.includes('srcDigitalCardId') || issue.path.includes('encryptedCard')
      )
    ) {
      return {
        actionCode: 'ERROR',
        error: error(
          'CARD_MISSING',
          `The "srcDigitalCardId" or "encryptedCard" parameter is required but is missing.`,
          issues
        ).error,
        bindingStatus: 'UNBIND'
      };
    }

    return {
      actionCode: 'ERROR',
      error: invalidParam(issues).error,
      bindingStatus: 'UNBIND'
    };
  }

  return result.data;
}
//END GENAI@CHATGPT4

//START GENAI@COPILOT
/**
 * START GENAI@GHCOPILOT
 * This function initiates the checkout process.
 * @param rawInput The input for the checkout API.
 * @returns The response from the checkout API.
 * END GENAI@GHCOPILOT
 */
export default async function checkout(rawInput: CheckoutRequest) {
  markStart('vsb_merchant_pov_checkout');
  const validatedInput = validateInput(rawInput);

  if ('actionCode' in validatedInput && validatedInput.actionCode === 'ERROR') {
    // START GENAI@GHCOPILOT
    pushUctpCheckout(`actionCode: ${validatedInput.actionCode}`);
    // END GENAI@GHCOPILOT
    return validatedInput;
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  const response = await orchCheckout(validatedInput as any);

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (response && 'error' in response) {
    /* START GENAI@GHCOPILOT */
    const step = `VSB_CHECKOUT_API_FAILED_RESPONSE`;
    pushEvents({
      E: step,
      CO: 'VSB_SDK_V2'
    });
    /* END GENAI@GHCOPILOT */

    markEnd('vsb_merchant_pov_checkout', { doFlush: true, failure: true });
    // START GENAI@GHCOPILOT
    pushUctpCheckout(`error: ${response.error}`);
    // END GENAI@GHCOPILOT

    return {
      actionCode: 'ERROR',
      error: response.error,
      bindingStatus: 'UNBIND'
    };
  }

  /* START GENAI@GHCOPILOT */
  const step = `VSB_CHECKOUT_API_SUCCESS_RESPONSE`;
  pushEvents({
    E: step,
    CO: 'VSB_SDK_V2'
  });
  /* END GENAI@GHCOPILOT */

  markEnd('vsb_merchant_pov_checkout', { doFlush: true });

  // START GENAI@GHCOPILOT
  pushUctpCheckout('');
  // END GENAI@GHCOPILOT
  return response;
}
//END GENAI@COPILOT
